import { ERROR_CODE } from '../constants';

export default {
  shared: {
    lib: {
      keycloak: {
        error: {
          [ERROR_CODE.invalid_grant]: 'Login yoki parol noto‘g‘ri, yoki token muddati tugagan.',
          [ERROR_CODE.invalid_request]: 'So‘rov noto‘g‘ri tuzilgan. Maʼlumotlarni tekshiring.',
          [ERROR_CODE.unsupported_grant_type]: 'Ushbu avtorizatsiya turi qo‘llab-quvvatlanmaydi.',
          [ERROR_CODE.invalid_scope]: 'So‘ralgan scope noto‘g‘ri yoki ruxsat etilmagan.',
          [ERROR_CODE.unauthorized_client]: 'Mijoz (client) bu amalni bajarish uchun ruxsatga ega emas.',
        },
        defaultError: '[FE] Nomaʼlum xatolik',
      },
    },
  },
};
